import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { supabaseClient } from '../../services/supabase';

// Auth0認証ありのヘッダー
function AuthenticatedHeader() {
  const { logout, user } = useAuth0();
  // データベース側で「管理者」と認識されているか（null: 確認中/確認不可）
  const [dbAdmin, setDbAdmin] = React.useState(null);

  React.useEffect(() => {
    let cancelled = false;
    supabaseClient.rpc('is_admin').then(({ data, error }) => {
      if (!cancelled) setDbAdmin(error ? null : data === true);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <header className="admin-header">
      <div className="container">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h1>よし鮨 管理者画面</h1>
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            {dbAdmin !== null && (
              <span
                style={{ color: dbAdmin ? '#4caf50' : '#ff9800', fontSize: '0.8rem' }}
                title="データベース上で管理者として認識されているか"
              >
                DB権限: {dbAdmin ? '管理者' : '未認証'}
              </span>
            )}
            {user && (
              <span style={{ color: '#ffffff', fontSize: '0.9rem' }}>
                {user.name || user.email}
              </span>
            )}
            <button
              onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
              className="btn-secondary"
              style={{ padding: '8px 16px', fontSize: '0.9rem' }}
            >
              ログアウト
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}

// 認証なしのヘッダー（開発用/Auth0未設定時）
function UnauthenticatedHeader() {
  return (
    <header className="admin-header">
      <div className="container">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h1>よし鮨 管理者画面</h1>
          <span style={{ color: '#ff9800', fontSize: '0.9rem' }}>
            ※認証なしモード
          </span>
        </div>
      </div>
    </header>
  );
}

// メインのHeaderコンポーネント
function Header({ skipAuth = false }) {
  if (skipAuth) {
    return <UnauthenticatedHeader />;
  }
  return <AuthenticatedHeader />;
}

export default Header;

